// import { useEffect, useMemo, useState } from 'react';
// import { getMetaLiveInsights } from '../../../../utils/api/reportApi';
// import styles from '../../MetaReportViewer.module.css';
// import AudienceEfficiencyMatrixSection from './AudienceEfficiencyMatrixSection';
// import { deriveAudienceMatrixFromRawRange } from './audienceMatrixData';
// import { deriveAdsLevelFromRawRange } from './adsLevelData';
// import AdLevelAssessmentSection from './AdLevelAssessmentSection';
// import CampaignLevelAssessmentSection from './CampaignLevelAssessmentSection';
// import { DateRangePicker } from './CampaignPerformanceExplorer';

// const CONFIDENCE_STYLE = {
//   High: { bg: '#dcfce7', color: '#15803d', border: '#86efac' },
//   Medium: { bg: '#fef9c3', color: '#a16207', border: '#fde047' },
//   Low: { bg: '#fee2e2', color: '#b91c1c', border: '#fca5a5' },
// };

// const deriveTotalsFromRawRange = (monthEntries = []) => {
//   if (!monthEntries.length) return null;

//   const currency = monthEntries.find((entry) => entry?.raw?.currency)?.raw?.currency || null;
//   const raw = monthEntries.reduce((acc, entry) => {
//     const row = entry?.raw || {};
//     acc.total_spend += Number(row.total_spend) || 0;
//     acc.total_clicks += Number(row.total_clicks) || 0;
//     acc.total_impressions += Number(row.total_impressions) || 0;
//     acc.total_conversions += Number(row.total_conversions) || 0;
//     acc.total_revenue += Number(row.total_revenue) || 0;
//     acc.total_landing_page_views += Number(row.total_landing_page_views) || 0;
//     acc.total_add_to_cart += Number(row.total_add_to_cart) || 0;
//     acc.total_initiate_checkout += Number(row.total_initiate_checkout) || 0;
//     acc.total_engagements += Number(row.total_engagements) || 0;
//     acc.total_repeat_customers += Number(row.total_repeat_customers) || 0;
//     acc.total_cltv90 += Number(row.total_cltv90) || 0;
//     acc.cltv_count += Number(row.cltv_count) || 0;
//     acc.total_new_customers += Number(row.total_new_customers) || 0;
//     acc.total_matched_order_revenue += Number(row.total_matched_order_revenue) || 0;
//     acc.total_matched_order_count += Number(row.total_matched_order_count) || 0;
//     acc.total_cltv30_revenue += Number(row.total_cltv30_revenue) || 0;
//     acc.total_cltv60_revenue += Number(row.total_cltv60_revenue) || 0;
//     acc.cltv_window_count += Number(row.cltv_window_count) || 0;
//     acc.total_orders_reviewed += Number(row.total_orders_reviewed) || 0;
//     acc.orders_with_meta_utm += Number(row.orders_with_meta_utm) || 0;
//     acc.orders_with_no_utm += Number(row.orders_with_no_utm) || 0;
//     acc.orders_with_other_utm += Number(row.orders_with_other_utm) || 0;
//     acc.total_matched_orders += Number(row.total_matched_orders) || 0;
//     acc.matched_orders_with_meta_utm += Number(row.matched_orders_with_meta_utm) || 0;
//     acc.matched_orders_with_no_utm += Number(row.matched_orders_with_no_utm) || 0;
//     acc.matched_orders_with_other_utm += Number(row.matched_orders_with_other_utm) || 0;
//     // Pre-computed averages may live directly on the entry object (not inside entry.raw).
//     // Check both locations so we catch whichever format the backend uses.
//     const directAov = row.aov ?? entry?.aov;
//     const directAvg30 = row.avg_30_day_cltv ?? entry?.avg_30_day_cltv;
//     const directAvg60 = row.avg_60_day_cltv ?? entry?.avg_60_day_cltv;
//     const directAvg90 = row.avg_90_day_cltv ?? entry?.avg_90_day_cltv;
//     const directVcac = row.value_to_cac_ratio ?? entry?.value_to_cac_ratio;
//     // Weight AOV by purchases, CLTV by new customers (purchase-weighted average across months)
//     const orderCount = Number(row.total_matched_order_count) || Number(row.total_conversions) || Number(entry?.purchases) || 0;
//     const newCust = Number(row.total_new_customers) || Number(entry?.new_customers) || 0;
//     if (directAov != null) { acc._aov_sum += (Number(directAov) || 0) * orderCount; acc._aov_weight += orderCount; }
//     // Fall back to purchase count as weight when new-customer count isn't tracked
//     const cltvWeight = newCust || orderCount || 1;
//     if (directAvg30 != null) { acc._avg30_sum += (Number(directAvg30) || 0) * cltvWeight; acc._avg30_weight += cltvWeight; }
//     if (directAvg60 != null) { acc._avg60_sum += (Number(directAvg60) || 0) * cltvWeight; acc._avg60_weight += cltvWeight; }
//     if (directAvg90 != null) { acc._avg90_sum += (Number(directAvg90) || 0) * cltvWeight; acc._avg90_weight += cltvWeight; }
//     if (directVcac != null) { acc._vcac_sum += Number(directVcac) || 0; acc._vcac_count += 1; }
//     return acc;
//   }, {
//     total_spend: 0, total_clicks: 0, total_impressions: 0, total_conversions: 0,
//     total_revenue: 0, total_landing_page_views: 0, total_add_to_cart: 0,
//     total_initiate_checkout: 0, total_engagements: 0, total_repeat_customers: 0,
//     total_cltv90: 0, cltv_count: 0, total_new_customers: 0,
//     total_matched_order_revenue: 0, total_matched_order_count: 0,
//     total_cltv30_revenue: 0, total_cltv60_revenue: 0, cltv_window_count: 0,
//     total_orders_reviewed: 0, orders_with_meta_utm: 0, orders_with_no_utm: 0,
//     orders_with_other_utm: 0, total_matched_orders: 0,
//     matched_orders_with_meta_utm: 0, matched_orders_with_no_utm: 0, matched_orders_with_other_utm: 0,
//     _aov_sum: 0, _aov_weight: 0,
//     _avg30_sum: 0, _avg30_weight: 0,
//     _avg60_sum: 0, _avg60_weight: 0,
//     _avg90_sum: 0, _avg90_weight: 0,
//     _vcac_sum: 0, _vcac_count: 0,
//   });

//   const round = (value, digits = 2) => Number((Number(value) || 0).toFixed(digits));
//   const ctr = raw.total_impressions > 0 ? round((raw.total_clicks / raw.total_impressions) * 100) : 0;
//   const cpc = raw.total_clicks > 0 ? round(raw.total_spend / raw.total_clicks) : 0;
//   const cpm = raw.total_impressions > 0 ? round((raw.total_spend / raw.total_impressions) * 1000) : 0;
//   const roas = raw.total_spend > 0 ? round(raw.total_revenue / raw.total_spend) : 0;
//   const bounceRate = raw.total_clicks > 0 ? round(((raw.total_clicks - raw.total_landing_page_views) / raw.total_clicks) * 100) : 0;
//   const cac = raw.total_new_customers > 0 ? round(raw.total_spend / raw.total_new_customers) : null;
//   // Prefer sum/count-based computation; fall back to weighted average of direct pre-computed values.
//   const avg90 = raw.cltv_count > 0
//     ? round(raw.total_cltv90 / raw.cltv_count)
//     : (raw._avg90_weight > 0 ? round(raw._avg90_sum / raw._avg90_weight) : null);
//   const aov = raw.total_matched_order_count > 0
//     ? round(raw.total_matched_order_revenue / raw.total_matched_order_count)
//     : (raw._aov_weight > 0 ? round(raw._aov_sum / raw._aov_weight) : null);
//   const avg30 = raw.cltv_window_count > 0
//     ? round(raw.total_cltv30_revenue / raw.cltv_window_count)
//     : (raw._avg30_weight > 0 ? round(raw._avg30_sum / raw._avg30_weight) : null);
//   const avg60 = raw.cltv_window_count > 0
//     ? round(raw.total_cltv60_revenue / raw.cltv_window_count)
//     : (raw._avg60_weight > 0 ? round(raw._avg60_sum / raw._avg60_weight) : null);
//   const valueToCacRatio = (cac && cac > 0 && avg30 != null)
//     ? round(avg30 / cac)
//     : (raw._vcac_count > 0 ? round(raw._vcac_sum / raw._vcac_count) : null);

//   let attributionConfidence = null;
//   if (raw.total_orders_reviewed > 0) {
//     const ratio = raw.orders_with_meta_utm / raw.total_orders_reviewed;
//     if (ratio >= 0.6) attributionConfidence = 'High';
//     else if (ratio >= 0.3) attributionConfidence = 'Medium';
//     else attributionConfidence = 'Low';
//   }

//   return {
//     currency,
//     spend: round(raw.total_spend),
//     clicks: raw.total_clicks,
//     impressions: raw.total_impressions,
//     purchases: raw.total_conversions,
//     revenue: round(raw.total_revenue),
//     ctr,
//     cpc,
//     cpm,
//     roas,
//     landing_page_views: raw.total_landing_page_views,
//     bounce_rate: bounceRate,
//     engagements: raw.total_engagements,
//     add_to_cart: raw.total_add_to_cart,
//     initiate_checkout: raw.total_initiate_checkout,
//     repeat_customers: raw.total_repeat_customers,
//     avg_90_day_cltv: avg90,
//     new_customers: raw.total_new_customers || null,
//     aov,
//     cac,
//     avg_30_day_cltv: avg30,
//     avg_60_day_cltv: avg60,
//     value_to_cac_ratio: valueToCacRatio,
//     attribution_confidence: attributionConfidence,
//     attribution_detail: raw.total_orders_reviewed > 0 ? {
//       total_orders_reviewed: raw.total_orders_reviewed,
//       orders_with_meta_utm: raw.orders_with_meta_utm,
//       orders_with_no_utm: raw.orders_with_no_utm,
//       orders_with_other_utm: raw.orders_with_other_utm,
//       total_matched_orders: raw.total_matched_orders,
//       matched_orders_with_meta_utm: raw.matched_orders_with_meta_utm,
//       matched_orders_with_no_utm: raw.matched_orders_with_no_utm,
//       matched_orders_with_other_utm: raw.matched_orders_with_other_utm,
//     } : null,
//     user_analyzed: false,
//     analyzation: '',
//   };
// };


// // Returns true when the exact date range doesn't cover full calendar months
// // (e.g. "Last 7 days" = April 8–14, not the full April 1–30)
// const isSubMonthlyRange = (since, until, fromMonth, toMonth) => {
//   if (!since || !until || !fromMonth || !toMonth) return false;
//   const sinceDate = new Date(`${since}T00:00:00`);
//   const untilDate = new Date(`${until}T00:00:00`);
//   // Start must be exactly the 1st of fromMonth
//   const fromStart = new Date(`${fromMonth}-01T00:00:00`);
//   if (sinceDate.getTime() !== fromStart.getTime()) return true;
//   // End must be exactly the last day of toMonth
//   const toEnd = new Date(
//     new Date(`${toMonth}-01T00:00:00`).getFullYear(),
//     new Date(`${toMonth}-01T00:00:00`).getMonth() + 1,
//     0,
//   );
//   if (untilDate.getTime() !== toEnd.getTime()) return true;
//   return false;
// };

// const OverallTab = ({
//   root,
//   userId,
//   authToken,
//   reportId,
//   shopId,
//   monthKeys,
//   fromMonth,
//   toMonth,
//   since,
//   until,
//   onRangeChange,
//   onShowCampaignPerformance,
//   onAdsetAssessmentSaved,
//   onAdAssessmentSaved,
//   onCampaignAssessmentSaved,
// }) => {
//   const [selectedAdset, setSelectedAdset] = useState(null);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);
//   const [liveData, setLiveData] = useState(null);
//   const [isLiveLoading, setIsLiveLoading] = useState(false);

//   const needsLiveData = useMemo(
//     () => isSubMonthlyRange(since, until, fromMonth, toMonth),
//     [since, until, fromMonth, toMonth],
//   );

//   useEffect(() => {
//     if (!needsLiveData || !userId || !since || !until) {
//       setLiveData(null);
//       return undefined;
//     }
//     let cancelled = false;
//     setIsLiveLoading(true);
//     setLiveData(null);
//     getMetaLiveInsights({ userId, reportId, shopId, since, until, authToken })
//       .then((result) => {
//         if (cancelled) return;
//         if (result?.ok) setLiveData(result);
//       })
//       .catch(() => {
//         if (cancelled) return;
//         setLiveData(null);
//       })
//       .finally(() => {
//         if (!cancelled) setIsLiveLoading(false);
//       });
//     return () => { cancelled = true; };
//   }, [userId, reportId, shopId, since, until, needsLiveData, authToken]);
//   const totalsRoot = root?.campaign_performance_totals || null;
//   const rangeHelper = totalsRoot?.range_helper || null;
//   const helperMonths = useMemo(
//     () => (Array.isArray(rangeHelper?.available_months) ? [...rangeHelper.available_months].sort().reverse() : []),
//     [rangeHelper],
//   );
//   const campaignLevelAssessment = root?.campaign_level_assessment || null;
//   const audienceMatrixRoot = root?.audience_efficiency_matrix_data || null;
//   const adsLevelRoot = root?.ads_level_assessment || null;
//   const audienceRangeHelper = audienceMatrixRoot?.range_helper || null;
//   const adsLevelRangeHelper = adsLevelRoot?.range_helper || null;
//   const audienceHelperMonths = useMemo(
//     () => (
//       Array.isArray(audienceRangeHelper?.available_months)
//         ? [...audienceRangeHelper.available_months].sort().reverse()
//         : []
//     ),
//     [audienceRangeHelper],
//   );
//   const hasDynamicWindow = helperMonths.length > 0 && rangeHelper?.by_month;
//   const selectedMonths = hasDynamicWindow
//     ? helperMonths.filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
//     : [];
//   const allMonthsSelected = hasDynamicWindow && selectedMonths.length === helperMonths.length;
//   const selectedMonthEntries = hasDynamicWindow
//     ? selectedMonths.map((monthKey) => rangeHelper?.by_month?.[monthKey]).filter(Boolean)
//     : [];

//   // Reference month keys computed once for bucket detection
//   const refMonthKeys = useMemo(() => {
//     const now = new Date();
//     const mk = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
//     return {
//       // Last completed calendar month (e.g. March when today is April)
//       lastCalMonth: mk(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
//       // Start of the rolling 3-month window ending last calendar month
//       quarterFrom: mk(new Date(now.getFullYear(), now.getMonth() - 3, 1)),
//       // Start of the rolling 12-month window ending last calendar month
//       yearFrom: mk(new Date(now.getFullYear() - 1, now.getMonth(), 1)),
//     };
//   }, []);

//   const totals = (() => {
//     // Sub-monthly live data takes highest priority when loaded
//     if (needsLiveData && liveData?.totals) return liveData.totals;

//     if (!hasDynamicWindow) return totalsRoot?.all_time || totalsRoot;
//     // All months selected → pre-computed all-time (has correct CLTV/AOV)
//     if (allMonthsSelected) return totalsRoot?.all_time || totalsRoot;

//     const { lastCalMonth, quarterFrom, yearFrom } = refMonthKeys;

//     // Selection = exactly last calendar month → use pre-computed last_month bucket
//     if (
//       totalsRoot?.last_month
//       && selectedMonths.length === 1
//       && selectedMonths[0] === lastCalMonth
//     ) return totalsRoot.last_month;

//     // Selection covers up to last calendar month and starts within the rolling quarter
//     if (
//       totalsRoot?.last_quarter
//       && toMonth <= lastCalMonth
//       && fromMonth >= quarterFrom
//       && fromMonth <= lastCalMonth
//     ) return totalsRoot.last_quarter;

//     // Selection covers up to last calendar month and starts within the rolling year
//     if (
//       totalsRoot?.last_year
//       && toMonth <= lastCalMonth
//       && fromMonth >= yearFrom
//     ) return totalsRoot.last_year;

//     return deriveTotalsFromRawRange(selectedMonthEntries) || totalsRoot?.all_time || totalsRoot;
//   })();

//   // Live campaign rows for sub-monthly windows (replaces pre-computed monthly data)
//   const liveCampaigns = needsLiveData && liveData?.campaigns ? liveData.campaigns : null;
//   const selectedAudienceEntries = audienceHelperMonths.length > 0
//     ? audienceHelperMonths
//         .filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
//         .map((monthKey) => audienceRangeHelper?.by_month?.[monthKey])
//         .filter(Boolean)
//     : [];
//   const audienceMatrixBase = audienceHelperMonths.length > 0
//     ? (deriveAudienceMatrixFromRawRange(selectedAudienceEntries) || audienceMatrixRoot?.all_time || audienceMatrixRoot)
//     : audienceMatrixRoot;
//   const audienceMatrix = useMemo(() => {
//     if (!audienceMatrixBase?.rows?.length || !selectedCampaign) return audienceMatrixBase;
//     const campaignId = String(selectedCampaign.campaign_id || '').trim();
//     const campaignName = String(selectedCampaign.campaign_name || '').trim();
//     const filteredRows = audienceMatrixBase.rows.filter((row) => (
//       (campaignId && String(row?.campaign_id || '').trim() === campaignId)
//       || (campaignName && String(row?.campaign_name || '').trim() === campaignName)
//     ));
//     return filteredRows.length ? { ...audienceMatrixBase, rows: filteredRows } : audienceMatrixBase;
//   }, [audienceMatrixBase, selectedCampaign]);
//   const adsLevelEntries = Array.isArray(adsLevelRangeHelper?.available_months)
//     ? [...adsLevelRangeHelper.available_months]
//         .sort()
//         .reverse()
//         .filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
//         .map((monthKey) => adsLevelRangeHelper?.by_month?.[monthKey])
//         .filter(Boolean)
//     : [];
//   const adsLevelMatrix = Array.isArray(adsLevelRangeHelper?.available_months)
//     ? ({
//         ...(deriveAdsLevelFromRawRange(adsLevelEntries) || adsLevelRoot?.all_time || adsLevelRoot),
//         assessments: adsLevelRoot?.assessments || {},
//       })
//     : adsLevelRoot;
//   const currency = totals?.currency || totalsRoot?.currency || null;
//   const summary = typeof root?.summary === 'string' ? root.summary.trim() : '';

//   const fmtNum = (value, dec = 2) => value != null ? Number(value).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }) : '—';
//   const cur = (value) => value != null ? (currency ? `${currency} ${fmtNum(value)}` : fmtNum(value)) : '—';
//   const pct = (value) => value != null ? `${fmtNum(value, 2)}%` : '—';

//   const confidence = totals?.attribution_confidence || null;
//   const confStyle = confidence ? CONFIDENCE_STYLE[confidence] : null;
//   const attrDetail = totals?.attribution_detail || null;

//   const tileGroups = totals ? [
//     {
//       label: 'Spend & Returns',
//       tiles: [
//         { label: 'Spend', value: cur(totals.spend) },
//         { label: 'Revenue', value: cur(totals.revenue) },
//         { label: 'ROAS', value: totals.roas != null ? `${fmtNum(totals.roas, 2)}×` : '—' },
//         { label: 'CPC', value: cur(totals.cpc) },
//         { label: 'CPM', value: cur(totals.cpm) },
//       ],
//     },
//     {
//       label: 'Reach & Engagement',
//       tiles: [
//         { label: 'Impressions', value: fmtNum(totals.impressions, 0) },
//         { label: 'Clicks', value: fmtNum(totals.clicks, 0) },
//         { label: 'CTR', value: pct(totals.ctr) },
//         { label: 'Bounce Rate', value: pct(totals.bounce_rate) },
//         { label: 'Engagements', value: fmtNum(totals.engagements, 0) },
//       ],
//     },
//     {
//       label: 'Funnel',
//       tiles: [
//         { label: 'Add to Cart', value: fmtNum(totals.add_to_cart, 0) },
//         { label: 'Init. Checkout', value: fmtNum(totals.initiate_checkout, 0) },
//         { label: 'Purchases', value: fmtNum(totals.purchases, 0) },
//         { label: 'AOV', value: cur(totals.aov) },
//       ],
//     },
//     {
//       label: 'Customer Acquisition',
//       tiles: [
//         { label: 'New Customers', value: totals.new_customers != null ? fmtNum(totals.new_customers, 0) : '—' },
//         { label: 'Repeat Customers', value: fmtNum(totals.repeat_customers, 0) },
//         { label: 'CAC', value: cur(totals.cac) },
//         { label: '30d CLTV', value: cur(totals.avg_30_day_cltv) },
//         { label: '60d CLTV', value: cur(totals.avg_60_day_cltv) },
//         { label: '90d CLTV', value: cur(totals.avg_90_day_cltv) },
//         { label: 'CLTV : CAC', value: totals.value_to_cac_ratio != null ? `${fmtNum(totals.value_to_cac_ratio, 2)}×` : '—' },
//       ],
//     },
//   ] : [];

//   return (
//     <>
//       {hasDynamicWindow && (
//         <div className={styles.explorerControls}>
//           <DateRangePicker
//             monthKeys={monthKeys}
//             fromMonth={fromMonth}
//             toMonth={toMonth}
//             onChange={onRangeChange}
//           />
//           {isLiveLoading && (
//             <span className={styles.liveInsightsBadge}>Fetching live data…</span>
//           )}
//           {needsLiveData && !isLiveLoading && liveData && (
//             <span className={styles.liveInsightsBadge} style={{ opacity: 0.7 }}>Live · {since} – {until}</span>
//           )}
//         </div>
//       )}
//       {confidence && confStyle && (
//         <div className={styles.attributionBanner} style={{ background: confStyle.bg, borderColor: confStyle.border }}>
//           <span className={styles.attributionBannerLabel} style={{ color: confStyle.color }}>
//             Attribution Confidence
//           </span>
//           <span className={styles.attributionBadge} style={{ background: confStyle.bg, color: confStyle.color, borderColor: confStyle.border }}>
//             {confidence}
//           </span>
//           {attrDetail && (
//             <span className={styles.attributionDetail} style={{ color: confStyle.color }}>
//               {attrDetail.orders_with_meta_utm} of {attrDetail.total_orders_reviewed || attrDetail.total_matched_orders} orders reviewed have Meta UTM
//               {attrDetail.orders_with_no_utm > 0 && ` · ${attrDetail.orders_with_no_utm} without any UTM`}
//               {attrDetail.orders_with_other_utm > 0 && ` · ${attrDetail.orders_with_other_utm} with other UTM sources`}
//             </span>
//           )}
//         </div>
//       )}
//       {tileGroups.length > 0 && tileGroups.map((group) => (
//         <div key={group.label} className={styles.totalsGroup}>
//           <span className={styles.totalsGroupLabel}>{group.label}</span>
//           <div className={styles.totalsBar}>
//             {group.tiles.map((tile) => (
//               <div key={tile.label} className={styles.totalsTile}>
//                 <span className={styles.totalsLabel}>{tile.label}</span>
//                 <span className={styles.totalsValue}>{tile.value}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}
//       {summary && (
//         <div className={styles.summaryCard}>
//           <p className={styles.summaryLabel}>Summary</p>
//           <p className={styles.summaryText}>{summary}</p>
//         </div>
//       )}
//       <CampaignLevelAssessmentSection
//         campaignLevelAssessment={campaignLevelAssessment}
//         liveCampaigns={liveCampaigns}
//         currency={currency}
//         userId={userId}
//         authToken={authToken}
//         reportId={reportId}
//         shopId={shopId}
//         fromMonth={fromMonth}
//         toMonth={toMonth}
//         since={since}
//         until={until}
//         onAssessmentSaved={onCampaignAssessmentSaved}
//         onCampaignSelect={setSelectedCampaign}
//         onShowCampaignPerformance={onShowCampaignPerformance}
//       />
//       {audienceMatrix?.rows?.length > 0 && (
//         <AudienceEfficiencyMatrixSection
//           matrix={audienceMatrix}
//           currency={currency}
//           userId={userId}
//           authToken={authToken}
//           reportId={reportId}
//           shopId={shopId}
//           onAssessmentSaved={onAdsetAssessmentSaved}
//           onShowCampaignPerformance={onShowCampaignPerformance}
//           onSelectedAdsetChange={setSelectedAdset}
//         />
//       )}
//       {selectedAdset && adsLevelMatrix?.rows?.length > 0 && (
//         <AdLevelAssessmentSection
//           matrix={adsLevelMatrix}
//           selectedAdset={selectedAdset}
//           currency={currency}
//           userId={userId}
//           authToken={authToken}
//           reportId={reportId}
//           shopId={shopId}
//           onAssessmentSaved={onAdAssessmentSaved}
//           onShowCampaignPerformance={onShowCampaignPerformance}
//         />
//       )}
//     </>
//   );
// };

// export default OverallTab;



import { useMemo, useState } from 'react';
import styles from '../../MetaReportViewer.module.css';
import AudienceEfficiencyMatrixSection from './AudienceEfficiencyMatrixSection';
import { deriveAudienceMatrixFromRawRange } from './audienceMatrixData';
import { deriveAdsLevelFromRawRange } from './adsLevelData';
import AdLevelAssessmentSection from './AdLevelAssessmentSection';
import CampaignLevelAssessmentSection from './CampaignLevelAssessmentSection';
import { DateRangePicker } from './CampaignPerformanceExplorer';

const CONFIDENCE_STYLE = {
  High: { bg: '#dcfce7', color: '#15803d', border: '#86efac' },
  Medium: { bg: '#fef9c3', color: '#a16207', border: '#fde047' },
  Low: { bg: '#fee2e2', color: '#b91c1c', border: '#fca5a5' },
};

const normalizeDateKey = (value) => {
  if (!value) return null;
  return String(value).slice(0, 10);
};

const getWindowKeyFromRange = (rangeHelper, since, until) => {
  const byWindow = rangeHelper?.by_window || {};
  const normalizedSince = normalizeDateKey(since);
  const normalizedUntil = normalizeDateKey(until);

  if (!normalizedSince || !normalizedUntil) return null;

  return (
    Object.entries(byWindow).find(([, windowValue]) => (
      normalizeDateKey(windowValue?.start_date) === normalizedSince
      && normalizeDateKey(windowValue?.end_date) === normalizedUntil
    ))?.[0] || null
  );
};

const deriveTotalsFromRawRange = (monthEntries = []) => {
  if (!monthEntries.length) return null;

  const currency = monthEntries.find((entry) => entry?.raw?.currency)?.raw?.currency || null;

  const raw = monthEntries.reduce((acc, entry) => {
    const row = entry?.raw || {};

    acc.total_spend += Number(row.total_spend) || 0;
    acc.total_clicks += Number(row.total_clicks) || 0;
    acc.total_impressions += Number(row.total_impressions) || 0;
    acc.total_conversions += Number(row.total_conversions) || 0;
    acc.total_revenue += Number(row.total_revenue) || 0;
    acc.total_landing_page_views += Number(row.total_landing_page_views) || 0;
    acc.total_add_to_cart += Number(row.total_add_to_cart) || 0;
    acc.total_initiate_checkout += Number(row.total_initiate_checkout) || 0;
    acc.total_engagements += Number(row.total_engagements) || 0;
    acc.total_repeat_customers += Number(row.total_repeat_customers) || 0;
    acc.total_cltv90 += Number(row.total_cltv90) || 0;
    acc.cltv_count += Number(row.cltv_count) || 0;
    acc.total_new_customers += Number(row.total_new_customers) || 0;
    acc.total_matched_order_revenue += Number(row.total_matched_order_revenue) || 0;
    acc.total_matched_order_count += Number(row.total_matched_order_count) || 0;
    acc.total_cltv30_revenue += Number(row.total_cltv30_revenue) || 0;
    acc.total_cltv60_revenue += Number(row.total_cltv60_revenue) || 0;
    acc.cltv_window_count += Number(row.cltv_window_count) || 0;
    acc.total_orders_reviewed += Number(row.total_orders_reviewed) || 0;
    acc.orders_with_meta_utm += Number(row.orders_with_meta_utm) || 0;
    acc.orders_with_no_utm += Number(row.orders_with_no_utm) || 0;
    acc.orders_with_other_utm += Number(row.orders_with_other_utm) || 0;
    acc.total_matched_orders += Number(row.total_matched_orders) || 0;
    acc.matched_orders_with_meta_utm += Number(row.matched_orders_with_meta_utm) || 0;
    acc.matched_orders_with_no_utm += Number(row.matched_orders_with_no_utm) || 0;
    acc.matched_orders_with_other_utm += Number(row.matched_orders_with_other_utm) || 0;

    const directAov = row.aov ?? entry?.aov;
    const directAvg30 = row.avg_30_day_cltv ?? entry?.avg_30_day_cltv;
    const directAvg60 = row.avg_60_day_cltv ?? entry?.avg_60_day_cltv;
    const directAvg90 = row.avg_90_day_cltv ?? entry?.avg_90_day_cltv;
    const directVcac = row.value_to_cac_ratio ?? entry?.value_to_cac_ratio;

    const orderCount =
      Number(row.total_matched_order_count) ||
      Number(row.total_conversions) ||
      Number(entry?.purchases) ||
      0;

    const newCust =
      Number(row.total_new_customers) ||
      Number(entry?.new_customers) ||
      0;

    if (directAov != null) {
      acc._aov_sum += (Number(directAov) || 0) * orderCount;
      acc._aov_weight += orderCount;
    }

    const cltvWeight = newCust || orderCount || 1;

    if (directAvg30 != null) {
      acc._avg30_sum += (Number(directAvg30) || 0) * cltvWeight;
      acc._avg30_weight += cltvWeight;
    }
    if (directAvg60 != null) {
      acc._avg60_sum += (Number(directAvg60) || 0) * cltvWeight;
      acc._avg60_weight += cltvWeight;
    }
    if (directAvg90 != null) {
      acc._avg90_sum += (Number(directAvg90) || 0) * cltvWeight;
      acc._avg90_weight += cltvWeight;
    }
    if (directVcac != null) {
      acc._vcac_sum += Number(directVcac) || 0;
      acc._vcac_count += 1;
    }

    return acc;
  }, {
    total_spend: 0,
    total_clicks: 0,
    total_impressions: 0,
    total_conversions: 0,
    total_revenue: 0,
    total_landing_page_views: 0,
    total_add_to_cart: 0,
    total_initiate_checkout: 0,
    total_engagements: 0,
    total_repeat_customers: 0,
    total_cltv90: 0,
    cltv_count: 0,
    total_new_customers: 0,
    total_matched_order_revenue: 0,
    total_matched_order_count: 0,
    total_cltv30_revenue: 0,
    total_cltv60_revenue: 0,
    cltv_window_count: 0,
    total_orders_reviewed: 0,
    orders_with_meta_utm: 0,
    orders_with_no_utm: 0,
    orders_with_other_utm: 0,
    total_matched_orders: 0,
    matched_orders_with_meta_utm: 0,
    matched_orders_with_no_utm: 0,
    matched_orders_with_other_utm: 0,
    _aov_sum: 0,
    _aov_weight: 0,
    _avg30_sum: 0,
    _avg30_weight: 0,
    _avg60_sum: 0,
    _avg60_weight: 0,
    _avg90_sum: 0,
    _avg90_weight: 0,
    _vcac_sum: 0,
    _vcac_count: 0,
  });

  const round = (value, digits = 2) => Number((Number(value) || 0).toFixed(digits));

  const ctr = raw.total_impressions > 0 ? round((raw.total_clicks / raw.total_impressions) * 100) : 0;
  const cpc = raw.total_clicks > 0 ? round(raw.total_spend / raw.total_clicks) : 0;
  const cpm = raw.total_impressions > 0 ? round((raw.total_spend / raw.total_impressions) * 1000) : 0;
  const roas = raw.total_spend > 0 ? round(raw.total_revenue / raw.total_spend) : 0;
  const bounceRate = raw.total_clicks > 0
    ? round(((raw.total_clicks - raw.total_landing_page_views) / raw.total_clicks) * 100)
    : 0;
  const cac = raw.total_new_customers > 0 ? round(raw.total_spend / raw.total_new_customers) : null;

  const avg90 = raw.cltv_count > 0
    ? round(raw.total_cltv90 / raw.cltv_count)
    : (raw._avg90_weight > 0 ? round(raw._avg90_sum / raw._avg90_weight) : null);

  const aov = raw.total_matched_order_count > 0
    ? round(raw.total_matched_order_revenue / raw.total_matched_order_count)
    : (raw._aov_weight > 0 ? round(raw._aov_sum / raw._aov_weight) : null);

  const avg30 = raw.cltv_window_count > 0
    ? round(raw.total_cltv30_revenue / raw.cltv_window_count)
    : (raw._avg30_weight > 0 ? round(raw._avg30_sum / raw._avg30_weight) : null);

  const avg60 = raw.cltv_window_count > 0
    ? round(raw.total_cltv60_revenue / raw.cltv_window_count)
    : (raw._avg60_weight > 0 ? round(raw._avg60_sum / raw._avg60_weight) : null);

  const valueToCacRatio = (cac && cac > 0 && avg30 != null)
    ? round(avg30 / cac)
    : (raw._vcac_count > 0 ? round(raw._vcac_sum / raw._vcac_count) : null);

  let attributionConfidence = null;
  if (raw.total_orders_reviewed > 0) {
    const ratio = raw.orders_with_meta_utm / raw.total_orders_reviewed;
    if (ratio >= 0.6) attributionConfidence = 'High';
    else if (ratio >= 0.3) attributionConfidence = 'Medium';
    else attributionConfidence = 'Low';
  }

  return {
    currency,
    spend: round(raw.total_spend),
    clicks: raw.total_clicks,
    impressions: raw.total_impressions,
    purchases: raw.total_conversions,
    revenue: round(raw.total_revenue),
    ctr,
    cpc,
    cpm,
    roas,
    landing_page_views: raw.total_landing_page_views,
    bounce_rate: bounceRate,
    engagements: raw.total_engagements,
    add_to_cart: raw.total_add_to_cart,
    initiate_checkout: raw.total_initiate_checkout,
    repeat_customers: raw.total_repeat_customers,
    avg_90_day_cltv: avg90,
    new_customers: raw.total_new_customers || null,
    aov,
    cac,
    avg_30_day_cltv: avg30,
    avg_60_day_cltv: avg60,
    value_to_cac_ratio: valueToCacRatio,
    attribution_confidence: attributionConfidence,
    attribution_detail: raw.total_orders_reviewed > 0 ? {
      total_orders_reviewed: raw.total_orders_reviewed,
      orders_with_meta_utm: raw.orders_with_meta_utm,
      orders_with_no_utm: raw.orders_with_no_utm,
      orders_with_other_utm: raw.orders_with_other_utm,
      total_matched_orders: raw.total_matched_orders,
      matched_orders_with_meta_utm: raw.matched_orders_with_meta_utm,
      matched_orders_with_no_utm: raw.matched_orders_with_no_utm,
      matched_orders_with_other_utm: raw.matched_orders_with_other_utm,
    } : null,
    user_analyzed: false,
    analyzation: '',
  };
};

const isSubMonthlyRange = (since, until, fromMonth, toMonth) => {
  if (!since || !until || !fromMonth || !toMonth) return false;

  const sinceDate = new Date(`${since}T00:00:00`);
  const untilDate = new Date(`${until}T00:00:00`);
  const fromStart = new Date(`${fromMonth}-01T00:00:00`);
  const toEnd = new Date(
    new Date(`${toMonth}-01T00:00:00`).getFullYear(),
    new Date(`${toMonth}-01T00:00:00`).getMonth() + 1,
    0,
  );

  if (sinceDate.getTime() !== fromStart.getTime()) return true;
  if (untilDate.getTime() !== toEnd.getTime()) return true;
  return false;
};

const OverallTab = ({
  root,
  userId,
  authToken,
  reportId,
  shopId,
  monthKeys,
  fromMonth,
  toMonth,
  since,
  until,
  windowKey,
  onRangeChange,
  onShowCampaignPerformance,
  onAdsetAssessmentSaved,
  onAdAssessmentSaved,
  onCampaignAssessmentSaved,
}) => {
  const [selectedAdset, setSelectedAdset] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const totalsRoot = root?.campaign_performance_totals || null;
  const summaryTotals = root?.viewer_summary?.totals || null;
  const summaryWindows = root?.viewer_summary?.windows || null;
  const quickWindows = root?.viewer_summary?.quick_windows || null;
  const todayWindow = quickWindows?.today || null;
  const yesterdayWindow = quickWindows?.yesterday || null;
  const last7DaysWindow = quickWindows?.last_7_days || null;
  const last30DaysWindow = quickWindows?.last_30_days || null;
  const rangeHelper = totalsRoot?.range_helper || null;
  const helperMonths = useMemo(
    () => (Array.isArray(rangeHelper?.available_months) ? [...rangeHelper.available_months].sort().reverse() : []),
    [rangeHelper],
  );

  const campaignLevelAssessment = root?.campaign_level_assessment || null;
  const audienceMatrixRoot = root?.audience_efficiency_matrix_data || null;
  const adsLevelRoot = root?.ads_level_assessment || null;
  const audienceRangeHelper = audienceMatrixRoot?.range_helper || null;
  const adsLevelRangeHelper = adsLevelRoot?.range_helper || null;

  const audienceHelperMonths = useMemo(
    () => (
      Array.isArray(audienceRangeHelper?.available_months)
        ? [...audienceRangeHelper.available_months].sort().reverse()
        : []
    ),
    [audienceRangeHelper],
  );

  const selectedWindowKey = useMemo(
    () => windowKey || getWindowKeyFromRange(rangeHelper, since, until),
    [windowKey, rangeHelper, since, until],
  );

  const hasDynamicWindow = helperMonths.length > 0 && rangeHelper?.by_month;

  const selectedMonths = hasDynamicWindow
    ? helperMonths.filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
    : [];

  const allMonthsSelected = hasDynamicWindow && selectedMonths.length === helperMonths.length;

  const selectedMonthEntries = hasDynamicWindow
    ? selectedMonths.map((monthKey) => rangeHelper?.by_month?.[monthKey]).filter(Boolean)
    : [];

  const refMonthKeys = useMemo(() => {
    const now = new Date();
    const mk = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    return {
      lastCalMonth: mk(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
      quarterFrom: mk(new Date(now.getFullYear(), now.getMonth() - 3, 1)),
      yearFrom: mk(new Date(now.getFullYear() - 1, now.getMonth(), 1)),
    };
  }, []);

  const totals = (() => {
    if (selectedWindowKey && rangeHelper?.by_window?.[selectedWindowKey]?.totals) {
      return rangeHelper.by_window[selectedWindowKey].totals;
    }

    if (!hasDynamicWindow) return totalsRoot?.all_time || totalsRoot || summaryTotals;
    if (allMonthsSelected) return totalsRoot?.all_time || totalsRoot || summaryTotals;

    const { lastCalMonth, quarterFrom, yearFrom } = refMonthKeys;
    const exactSubMonth = isSubMonthlyRange(since, until, fromMonth, toMonth);

    if (
      totalsRoot?.last_month &&
      selectedMonths.length === 1 &&
      selectedMonths[0] === lastCalMonth &&
      !exactSubMonth
    ) return totalsRoot.last_month;

    if (
      totalsRoot?.last_quarter &&
      toMonth <= lastCalMonth &&
      fromMonth >= quarterFrom &&
      fromMonth <= lastCalMonth &&
      !exactSubMonth
    ) return totalsRoot.last_quarter;

    if (
      totalsRoot?.last_year &&
      toMonth <= lastCalMonth &&
      fromMonth >= yearFrom &&
      !exactSubMonth
    ) return totalsRoot.last_year;

    return deriveTotalsFromRawRange(selectedMonthEntries) || totalsRoot?.all_time || totalsRoot || summaryTotals;
  })();

  const selectedAudienceEntries = audienceHelperMonths.length > 0
    ? audienceHelperMonths
        .filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
        .map((monthKey) => audienceRangeHelper?.by_month?.[monthKey])
        .filter(Boolean)
    : [];

  const audienceMatrixBase = (() => {
    if (selectedWindowKey && audienceRangeHelper?.by_window?.[selectedWindowKey]) {
      return audienceRangeHelper.by_window[selectedWindowKey];
    }

    if (audienceHelperMonths.length > 0) {
      return deriveAudienceMatrixFromRawRange(selectedAudienceEntries) || audienceMatrixRoot?.all_time || audienceMatrixRoot;
    }

    return audienceMatrixRoot;
  })();

  const audienceMatrix = useMemo(() => {
    if (!audienceMatrixBase?.rows?.length || !selectedCampaign) return audienceMatrixBase;

    const campaignId = String(selectedCampaign.campaign_id || '').trim();
    const campaignName = String(selectedCampaign.campaign_name || '').trim();

    const filteredRows = audienceMatrixBase.rows.filter((row) => (
      (campaignId && String(row?.campaign_id || '').trim() === campaignId) ||
      (campaignName && String(row?.campaign_name || '').trim() === campaignName)
    ));

    return filteredRows.length ? { ...audienceMatrixBase, rows: filteredRows } : audienceMatrixBase;
  }, [audienceMatrixBase, selectedCampaign]);

  const adsLevelEntries = Array.isArray(adsLevelRangeHelper?.available_months)
    ? [...adsLevelRangeHelper.available_months]
        .sort()
        .reverse()
        .filter((monthKey) => monthKey >= fromMonth && monthKey <= toMonth)
        .map((monthKey) => adsLevelRangeHelper?.by_month?.[monthKey])
        .filter(Boolean)
    : [];

  const adsLevelMatrix = (() => {
    if (selectedWindowKey && adsLevelRangeHelper?.by_window?.[selectedWindowKey]) {
      return {
        ...adsLevelRangeHelper.by_window[selectedWindowKey],
        assessments: adsLevelRoot?.assessments || {},
      };
    }

    if (Array.isArray(adsLevelRangeHelper?.available_months)) {
      return {
        ...(deriveAdsLevelFromRawRange(adsLevelEntries) || adsLevelRoot?.all_time || adsLevelRoot),
        assessments: adsLevelRoot?.assessments || {},
      };
    }

    return adsLevelRoot;
  })();

  const currency = totals?.currency || totalsRoot?.currency || null;
  const summary = typeof root?.summary === 'string' ? root.summary.trim() : '';

  const fmtNum = (value, dec = 2) =>
    value != null
      ? Number(value).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec })
      : '—';

  const cur = (value) => value != null ? (currency ? `${currency} ${fmtNum(value)}` : fmtNum(value)) : '—';
  const pct = (value) => value != null ? `${fmtNum(value, 2)}%` : '—';

  const confidence = totals?.attribution_confidence || null;
  const confStyle = confidence ? CONFIDENCE_STYLE[confidence] : null;
  const attrDetail = totals?.attribution_detail || null;

  const tileGroups = totals ? [
    {
      label: 'Spend & Returns',
      tiles: [
        { label: 'Spend', value: cur(totals.spend) },
        { label: 'Revenue', value: cur(totals.revenue) },
        { label: 'ROAS', value: totals.roas != null ? `${fmtNum(totals.roas, 2)}×` : '—' },
        { label: 'CPC', value: cur(totals.cpc) },
        { label: 'CPM', value: cur(totals.cpm) },
      ],
    },
    {
      label: 'Reach & Engagement',
      tiles: [
        { label: 'Impressions', value: fmtNum(totals.impressions, 0) },
        { label: 'Clicks', value: fmtNum(totals.clicks, 0) },
        { label: 'CTR', value: pct(totals.ctr) },
        { label: 'Bounce Rate', value: pct(totals.bounce_rate) },
        { label: 'Engagements', value: fmtNum(totals.engagements, 0) },
      ],
    },
    {
      label: 'Funnel',
      tiles: [
        { label: 'Add to Cart', value: fmtNum(totals.add_to_cart, 0) },
        { label: 'Init. Checkout', value: fmtNum(totals.initiate_checkout, 0) },
        { label: 'Purchases', value: fmtNum(totals.purchases, 0) },
        { label: 'AOV', value: cur(totals.aov) },
      ],
    },
    {
      label: 'Customer Acquisition',
      tiles: [
        { label: 'New Customers', value: totals.new_customers != null ? fmtNum(totals.new_customers, 0) : '—' },
        { label: 'Repeat Customers', value: fmtNum(totals.repeat_customers, 0) },
        { label: 'CAC', value: cur(totals.cac) },
        { label: '30d CLTV', value: cur(totals.avg_30_day_cltv) },
        { label: '60d CLTV', value: cur(totals.avg_60_day_cltv) },
        { label: '90d CLTV', value: cur(totals.avg_90_day_cltv) },
        { label: 'CLTV : CAC', value: totals.value_to_cac_ratio != null ? `${fmtNum(totals.value_to_cac_ratio, 2)}×` : '—' },
      ],
    },
  ] : [];

  return (
    <>
      {hasDynamicWindow && (
        <div className={styles.explorerControls}>
<DateRangePicker
  monthKeys={monthKeys}
  fromMonth={fromMonth}
  toMonth={toMonth}
  since={since}
  until={until}
  onChange={onRangeChange}
/>
          {selectedWindowKey && (
            <span className={styles.liveInsightsBadge} style={{ opacity: 0.7 }}>
              {rangeHelper?.by_window?.[selectedWindowKey]?.label || selectedWindowKey}
            </span>
          )}
        </div>
      )}

      {confidence && confStyle && (
        <div className={styles.attributionBanner} style={{ background: confStyle.bg, borderColor: confStyle.border }}>
          <span className={styles.attributionBannerLabel} style={{ color: confStyle.color }}>
            Attribution Confidence
          </span>
          <span className={styles.attributionBadge} style={{ background: confStyle.bg, color: confStyle.color, borderColor: confStyle.border }}>
            {confidence}
          </span>
          {attrDetail && (
            <span className={styles.attributionDetail} style={{ color: confStyle.color }}>
              {attrDetail.orders_with_meta_utm} of {attrDetail.total_orders_reviewed || attrDetail.total_matched_orders} orders reviewed have Meta UTM
              {attrDetail.orders_with_no_utm > 0 && ` · ${attrDetail.orders_with_no_utm} without any UTM`}
              {attrDetail.orders_with_other_utm > 0 && ` · ${attrDetail.orders_with_other_utm} with other UTM sources`}
            </span>
          )}
        </div>
      )}

      {tileGroups.length > 0 && tileGroups.map((group) => (
        <div key={group.label} className={styles.totalsGroup}>
          <span className={styles.totalsGroupLabel}>{group.label}</span>
          <div className={styles.totalsBar}>
            {group.tiles.map((tile) => (
              <div key={tile.label} className={styles.totalsTile}>
                <span className={styles.totalsLabel}>{tile.label}</span>
                <span className={styles.totalsValue}>{tile.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}

      {(todayWindow || yesterdayWindow || last7DaysWindow || last30DaysWindow) && (() => {
        const qwEntries = [
          { key: 'today',        label: 'Today',       window: todayWindow },
          { key: 'yesterday',    label: 'Yesterday',   window: yesterdayWindow },
          { key: 'last_7_days',  label: 'Last 7 days', window: last7DaysWindow },
          { key: 'last_30_days', label: 'Last 30 days', window: last30DaysWindow },
        ].filter((e) => e.window?.totals);
        if (!qwEntries.length) return null;
        return (
          <div className={styles.totalsGroup}>
            <span className={styles.totalsGroupLabel}>Recent Windows</span>
            <div className={styles.totalsBar}>
              {qwEntries.map(({ key, label, window: w }) => (
                <div key={key} className={styles.totalsTile}>
                  <span className={styles.totalsLabel}>{label}</span>
                  <span className={styles.totalsValue}>{cur(w.totals.spend)}</span>
                  <span className={styles.totalsLabel} style={{ fontSize: '0.75em', opacity: 0.75 }}>
                    {`ROAS ${w.totals.roas != null ? `${fmtNum(w.totals.roas, 2)}×` : '—'}`}
                  </span>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {summary && (
        <div className={styles.summaryCard}>
          <p className={styles.summaryLabel}>Summary</p>
          <p className={styles.summaryText}>{summary}</p>
        </div>
      )}

      <CampaignLevelAssessmentSection
        campaignLevelAssessment={campaignLevelAssessment}
        selectedWindowKey={selectedWindowKey}
        currency={currency}
        userId={userId}
        authToken={authToken}
        reportId={reportId}
        shopId={shopId}
        fromMonth={fromMonth}
        toMonth={toMonth}
        since={since}
        until={until}
        onAssessmentSaved={onCampaignAssessmentSaved}
        onCampaignSelect={setSelectedCampaign}
        onShowCampaignPerformance={onShowCampaignPerformance}
      />

      {audienceMatrix?.rows?.length > 0 && (
        <AudienceEfficiencyMatrixSection
          matrix={audienceMatrix}
          selectedWindowKey={selectedWindowKey}
          currency={currency}
          userId={userId}
          authToken={authToken}
          reportId={reportId}
          shopId={shopId}
          onAssessmentSaved={onAdsetAssessmentSaved}
          onShowCampaignPerformance={onShowCampaignPerformance}
          onSelectedAdsetChange={setSelectedAdset}
        />
      )}

      {selectedAdset && adsLevelMatrix?.rows?.length > 0 && (
        <AdLevelAssessmentSection
          matrix={adsLevelMatrix}
          selectedWindowKey={selectedWindowKey}
          selectedAdset={selectedAdset}
          currency={currency}
          userId={userId}
          authToken={authToken}
          reportId={reportId}
          shopId={shopId}
          onAssessmentSaved={onAdAssessmentSaved}
          onShowCampaignPerformance={onShowCampaignPerformance}
        />
      )}
    </>
  );
};

export default OverallTab;
